import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
  
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { Signaletique } from '../entity/signalitique';
 


@Injectable()
export class SignaletiqueService {

  private baseUrl = environment.restApi;
  private signaletiqueUrl = `${this.baseUrl}signaletique`;
 
  
  constructor(private http: HttpClient ) { }




  get(id: number): Observable<Signaletique> {
    return this.http.get<Signaletique>(this.signaletiqueUrl + '/' + id);
  }
  
  
  getAll(): Observable<Signaletique[]> {
    return this.http.get<Signaletique[]>( `${this.signaletiqueUrl}` );
  }
 
 
  getAllBySalon(idSalon:number): Observable<Signaletique[]> {
    return this.http.get<Signaletique[]>( `${this.signaletiqueUrl}/getAllBySalon/${idSalon}` );
  }

  findAllUpdate( ): Observable<Signaletique[]> {
    return this.http.get<Signaletique[]>(this.signaletiqueUrl + '/findAllUpdate' );
  }
  private handleError(error) {
    //console.log(error);
  }
}
